import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout/Layout.vue'
import ApprovalIndex from '../views/layout/pages/Approval/index.vue'
import FeaturesIndex from '../views/layout/pages/Features/index.vue'
import Pwd from '../views/login/pwd.vue'
import Login from '../views/login/login.vue'
import fixRec from '../views/layout/pages/Features/fixRec.vue'
//待盘点物料
import waitCheck from '../views/layout/pages/Features/waitChk.vue'
import barFollow from '../views/layout/pages/Features/barFollow.vue'
//扫码入库单
import stkBarin from '../views/layout/pages/Features/stk_barin.vue'
import stkCheck from '../views/layout/pages/Features/stk_check.vue'

import matPrdOut from '../views/layout/pages/Features/mat_out.vue'
import ExpenseList from '../views/layout/pages/Approval/ExpenseList.vue'
import ExpenseDetail from '../views/layout/pages/Approval/ExpenseDetail.vue'
import PurchaseList from "@/views/layout/pages/Approval/PurchaseList.vue";
import PurchaseDetail from "@/views/layout/pages/Approval/PurchaseDetail.vue";
import SalesList from "@/views/layout/pages/Approval/SalesList.vue";
import SalesDetail from "@/views/layout/pages/Approval/SalesDetail.vue";
import ForecastList from "@/views/layout/pages/Approval/ForecastList.vue";
import ForecastDetail from "@/views/layout/pages/Approval/ForecastDetail.vue";
import StockIndex from "@/views/layout/pages/Features/stockCheck/index.vue";
import StockCheck from "@/views/layout/pages/Features/stockCheck/check.vue";
import WorkshopReport from "@/views/layout/pages/Features/workshopReport/index.vue";
import WorkshopReportDetail from "@/views/layout/pages/Features/workshopReport/detail.vue";
import PoCfmIndex from "@/views/layout/pages/Features/po_cfm.vue";
import PoCfmConfirm from "@/views/layout/pages/Features/poCfm/confirm.vue";
 
Vue.use(VueRouter)
//路由重复 报错解决办法 
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location ).catch(err => err)
};
  const routes = [
    //登录
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    // 与主项目保持一致的登录入口；保留根路径兼容旧链接。
    {
      path: '/login',
      name: 'LoginAlias',
      component: Login
    },
    //主布局（包含底部导航）
    {
      path: '/',
      component: Layout,
      children: [
        //功能管理（原首页）
        {
          path: '/features',
          name: 'Features',
          component: FeaturesIndex
        },
        //新首页 - 审批管理
        {
          path: '/approval',
          name: 'Approval',
          component: ApprovalIndex
        },
        
      ]
    },
    //报销审批列表
    {
      path: '/approval/expense/list',
      name: 'ExpenseList',
      component: ExpenseList
    },
    //报销审批详情
    {
      path: '/approval/expense/detail',
      name: 'ExpenseDetail',
      component: ExpenseDetail
    },
    //采购订单审批列表
    {
      path: '/approval/purchase/list',
      name: 'PurchaseList',
      component: PurchaseList
    },
    //采购订单审批详情
    {
      path: '/approval/purchase/detail',
      name: 'PurchaseDetail',
      component: PurchaseDetail
    },
    //销售单审批列表
    {
      path: '/approval/sales/list',
      name: 'SalesList',
      component: SalesList
    },
    //销售订单审批详情
    {
      path: '/approval/sales/detail',
      name: 'SalesDetail',
      component: SalesDetail
    },
    //预测单审批列表
    {
      path: '/approval/forecast/list',
      name: 'ForecastList',
      component: ForecastList
    },
    //预测单审批详情
    {
      path: '/approval/forecast/detail',
      name: 'ForecastDetail',
      component: ForecastDetail
    },
    //修改密码
    {
      path: '/pwd',
      name: 'Pwd',
      component: Pwd
    },
    //维修记录表
    {
      path: '/mobile/fix_rec',
      component: fixRec,
      name:'fixRec'
    },
    //收料暂收单
    {
      path: '/mobile/po_barcode',
      component: waitCheck,
      name:'waitCheck'
    },    
    // 暂收质检单
    {
      path: '/h5mgt/po_stkchk',
      component: stkCheck,
      name:'stkCheck'
    }, 
    //条码追踪单
    {
      path: '/mobile/bar_follow',
      component: barFollow,
      name:'barFollow'
    },
    //扫码入库单
    {
      path: '/mobile/stk_barin',
      component: stkBarin,
      name:'stkBarin'
    },
    //生产领料单
    {
      path: '/mobile/mat_out',
      component: matPrdOut,
      name:'matPrdOut'
    },
    //盘点表
    {
      path: '/mobile/stock_check',
      component: StockIndex,
      name:'StockIndex'
    },
    //盘点明细
    {
      path: '/stockCheck/check',
      component: StockCheck,
      name:'check'
    },
    //采购确认单列表
    {
      path: '/mobile/po_cfm',
      component: PoCfmIndex,
      name:'PoCfmIndex'
    },
    //采购确认单明细
    {
      path: '/poCfm/confirm',
      component: PoCfmConfirm,
      name:'PoCfmConfirm'
    },
    //车间工序报工
    {
      path: '/mobile/work_jobqty',
      component: WorkshopReport,
      name:'WorkshopReport'
    },
    //车间工序报工明细
    {
      path: '/workshopReport/detail',
      component: WorkshopReportDetail,
      name:'WorkshopReportDetail'
    },


  ]
const router = new VueRouter({
  mode: 'history',  //建议使用history模式 ,hash
  base: process.env.BASE_URL,
  routes
})

export default router
